import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, CardContent} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {setSeatAPIData} from '../actions/main.js';
import {CookieName, getCookie} from '../utils/cookieManager';
import '../App.scss';

class BuslistCard extends Component {
  handleOnClick = (bus) => {
    let usertoken = getCookie(CookieName.USERTOKEN);

    const sourceId = this.props.info.source.masterId;
    const destinationId = this.props.info.destination.masterId;
    const doj = this.props.info.doj;
    let seatapidata = {
      sid: sourceId,
      did: destinationId,
      doj: doj,
      bus,
      isAPSRTC: bus.Provider === 'APSRTC' ? true : false,
    };
    this.props.setSeatAPIData(seatapidata);
    if (usertoken) {
      this.props.history.push({
        pathname: '/rbooking-bus/seat-select',
      });
    } else {
      this.props.history.push({
        pathname: '/account-login',
        state: {defaultPath: '/rbooking-bus/seat-select'},
      });
    }
  };

  render() {
    let bus = this.props.busobj.buses;
    if (bus && bus.length > 0 && bus[0].hasOwnProperty('isRTC')) {
      bus = bus.slice(1);
    }
    const busblock = bus.map((bus) => {
      var policy = '';
      if (bus.RtcTag !== 'APSRTC') {
        let cp = bus.CancellationPolicy.split(';');
        // console.log(cp);
        cp.forEach((c) => {
          if (c.split(':')[2] === '0') {
            policy = `Free Cancellation ${
              c.split(':')[0]
            } hours before journey`;
          }
        });
      }

      return (
        <div key={bus.Id} id={bus.Id} onClick={(e) => this.handleOnClick(bus)}>
          <Card className="bus-card">
            <CardContent className="card-content">
              <Grid container justifyContent="flex-start">
                <Grid item xs={8} className="block-1">
                  <div>{bus.TravelsName}</div>
                  <div className="bus-type">{bus.Type}</div>
                  <div className="duration">
                    <span className="dtime">{bus.DepartureTime}</span>
                    <i className="arrow">→</i>
                    <span className="atime">{bus.ArrivalTime}</span>
                  </div>
                </Grid>
                <Grid item xs={4} className="block-2">
                  <div className="price">Rs {bus.Fare.TotalFare}</div>
                  <div>{bus.AvailableSeats} Seats</div>
                  <div>{bus.Duration} Hrs</div>
                </Grid>
              </Grid>
              <div className="policy">{policy}</div>
            </CardContent>
          </Card>
        </div>
      );
    });

    return <div className="bus">{busblock}</div>;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSeatAPIData: (query) => {
      dispatch(setSeatAPIData(query));
    },
  };
};

export default connect(null, mapDispatchToProps)(BuslistCard);
